import { withBonus } from "./chemStyleBonuses";
/**
 * Off-Balance Dribbling — the control a player keeps under pressure, new in
 * FC 27. EA gates it on the average of Balance, Agility and Dribbling; the
 * higher the average, the more control. Below the threshold the player does
 * not have it at all, so there is nothing to show.
 */
export const OFF_BALANCE_DRIBBLING_MIN = 75;
const OFF_BALANCE_DRIBBLING_STATS = ["agility", "balance", "dribbling"];
/** Undefined while any of the three stats is missing: an average of two is not the rating. */
const average = (inGameAttributes, specificStatsBonus) => {
    const values = OFF_BALANCE_DRIBBLING_STATS.map((key) => {
        const value = inGameAttributes?.[key];
        return value ? withBonus(value, specificStatsBonus?.[key] || 0) : undefined;
    });
    if (values.some((value) => value === undefined))
        return undefined;
    return Math.round(values.reduce((sum, value) => sum + value, 0) / values.length);
};
/**
 * The player's Off-Balance Dribbling rating with the chemstyle applied, and
 * how much of it the chemstyle added. Undefined when they do not reach the
 * threshold or the three stats are not all known.
 *
 * A chemstyle can carry a player over the threshold, so the rating is gated on
 * the boosted average — the same stats the game reads.
 */
export const calculateOffBalanceDribbling = (inGameAttributes, specificStatsBonus) => {
    const boosted = average(inGameAttributes, specificStatsBonus);
    if (boosted === undefined || boosted < OFF_BALANCE_DRIBBLING_MIN) {
        return undefined;
    }
    const base = average(inGameAttributes);
    return { value: boosted, bonus: boosted - (base ?? boosted) };
};
//# sourceMappingURL=offBalanceDribbling.js.map